import React from 'react'

const ProjectCarouselButtons = ({ tag }) => {
    return (
        <>
            <button className="carousel-control-prev" type="button"
                data-bs-target={`#carouselExampleIndicators${tag}`} data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button"
                data-bs-target={`#carouselExampleIndicators${tag}`} data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </>
    )
}

export default ProjectCarouselButtons;